module.exports = __webpack_public_path__ + "static/img/10.a2fd791.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/pc/body/icon-2/10.png
// module id = O+SV
// module chunks = 1